/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Card, Buttons } from '../../../../../bphComponents/bundle';
import ContentWrapper from '../../../../components/ContentWrapper';
import { getLocalText } from '../../../../../utilities/localizedUtil';
import PreformattedText from '../../../../components/PreformattedText';

const LeaveGroup = (props) => {
  const groupName = getLocalText(props.groupName, props.intl.locale)
  return (
    <ContentWrapper>
      <Card.CardShape>
        <Card.CardContent>
          <PreformattedText className="font-body">
            <FormattedMessage id="groupLeaveConfirm.confirm.message.text" values={{ string1: groupName, string2: groupName, string3: groupName }} />
          </PreformattedText>
        </Card.CardContent>
      </Card.CardShape>
      <Buttons.PrimaryButton className="theme-group base background" onClick={props.onConfirmLeave} alignText="center">
        <FormattedMessage id="groupLeaveConfirm.leave.button.label" />
      </Buttons.PrimaryButton>
    </ContentWrapper>
  );
}
LeaveGroup.propTypes = {
  profile: PropTypes.object,
  profileId: PropTypes.number,
  isMainProfile: PropTypes.bool,
  onGoToLeave: PropTypes.func,
  onConfirmLeave: PropTypes.func,
  groupName: PropTypes.any,
  intl: PropTypes.any,
};

export default injectIntl(LeaveGroup);
